import React, { useState } from "react";
import { EmailBuilderMediaGalleryModal } from "../../shell/panel/blockSettings/EmailBuilderMediaGalleryModal";
import { EmailBuilderSettingsImagePicker } from "./EmailBuilderSettingsImagePicker";

type BackgroundImageFieldProps = {
  value: string;
  onChange: (url: string) => void;
};

export function BackgroundImageField({
  value,
  onChange,
}: BackgroundImageFieldProps) {
  const [mediaOpen, setMediaOpen] = useState(false);
  const hasImage = value.trim().length > 0;

  return (
    <>
      <EmailBuilderSettingsImagePicker
        previewUrl={hasImage ? value : undefined}
        onOpen={() => setMediaOpen(true)}
        onRemove={() => onChange("")}
      />

      {mediaOpen ? (
        <EmailBuilderMediaGalleryModal
          mode={hasImage ? "replace" : "add"}
          isOpen
          onClose={() => setMediaOpen(false)}
          onConfirm={({ media }) => {
            onChange(media.source.trim());
          }}
        />
      ) : null}
    </>
  );
}
